const StatusMap = {
    PENDING: { status: 'PENDING', message: 'Ready to Create', color: '#CB8939' },
    FAIL:  { status: 'FAIL', message: 'Failed', color: '#F0235B' },
    IMPORTING_DATASETS: { status: 'IMPORTING_DATASETS', message: 'Importing datasets', color: '#9F2E95' },
    CREATING_MAP: { status: 'CREATING_MAP', message: 'Importing datasets', color: '#9F2E95' },
    COMPLETE:  { status: 'COMPLETE', message: 'Complete', color: 'green' },
}

module.exports = {
    StatusMap
}